import { BehaviorSubject } from 'rxjs'
import { ProHistoricalTransaction } from './ProHistoricalTransaction'
import link from 'infra/link'

/**
 * View model for a single historical transaction in the list.
 */
export class ProHistoricalTransactionViewModel {
  /**
   * Tracks whether the view model is active.
   */
  private readonly _active = new BehaviorSubject<boolean>(false)

  /**
   * Constructor.
   */
  constructor(public readonly transaction: ProHistoricalTransaction) {}

  /**
   * Activates the view model.
   */
  activate() {
    this._active.next(true)
  }

  /**
   * Deactivates the view model.
   */
  deactivate() {
    this._active.next(false)
  }

  /**
   * Views the job in a new window.
   */
  viewJob = () => {
    if (this.transaction.job?.id) {
      window.open(link.job(this.transaction.job.id), '_blank')
    }
  }
}
